import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {Screen} from '../../providers/models';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import {ItemComponent} from '../item/item.component';
import {Api} from '../../providers/api';
import {Auth} from '../../providers/auth';
import {EntitlementService, hasFeature} from '../../providers/entitlement.service';
import * as moment from 'moment';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [NgbDropdownConfig, ItemComponent, Api] // add NgbDropdownConfig to the component providers
})
export class HomeComponent implements OnInit {

  name: string;

  screens: Screen[];
  circuito;

  // tv-claim-pairing: unlink flow state. Unlink revokes the binding via
  // DELETE /api/pos/:id (existing endpoint, no new contract); tracker
  // history is kept server-side, so the TV needs re-pairing or manual IDs.
  showUnlinkModal = false;
  unlinkTarget: any = null;
  unlinkError: string = null;

  // Entitlement gate (contratos-congelados Slice D2, Q5): the whole actions
  // control is gated behind the combined multicaja||monitoreo flags via the
  // shared fail-open evaluator, so it hides ONLY when both flags are
  // explicitly false. Restore point: when PO names which sendAction values
  // are multicaja vs monitoreo, split into per-button gates (see template).
  actionsAllowed$: Observable<boolean>;

  constructor(config: NgbDropdownConfig,
              private route: ActivatedRoute,
              private router: Router, private spinner: NgxSpinnerService,
              private api: Api, private auth: Auth,
              private entitlement: EntitlementService) {
    this.name = '';
    moment.locale('es');
    this.actionsAllowed$ = this.entitlement.canUse$(function(e) {
      return hasFeature(e, 'multicaja') || hasFeature(e, 'monitoreo');
    });
    // customize default values of dropdowns used by this component tree
    config.placement = 'left-top';
    config.autoClose = true;
    this.auth.userCheck(() => {
      this.circuito = this.auth.circuito;
      this.spinner.show();
      this.loadScreens();
    }, (err) => {
      this.auth.logout();
    });
  }

  getRelativeTime(date) {
    return moment(date).fromNow();
  }

  loadScreens() {
    this.api.getEstado().subscribe((res: any) => {
      console.log(res);
      if (res && res.data) {
        this.screens = res.data.map(
          (screen) => {
            screen.fecha_relativa = this.getRelativeTime(screen.fecha);
            return screen;
          });
      } else {
        this.screens = [];
      }
      this.spinner.hide();
    }, err => {
      this.auth.checkError(err);
      this.spinner.hide();
    });
  }

  ngOnInit() {
  }

  showOptionesRow(screen) {
    console.log(screen);
  }

  setAction(id, action) {
    this.api.sendAction(id, action).subscribe((res: any) => {
      console.log(res);
    }, (err) => {
      console.log(err);
    });
  }

  askUnlink(screen) {
    this.unlinkTarget = screen;
    this.unlinkError = null;
    this.showUnlinkModal = true;
  }

  cancelUnlink() {
    this.unlinkTarget = null;
    this.showUnlinkModal = false;
  }

  confirmUnlink() {
    const target = this.unlinkTarget;
    this.showUnlinkModal = false;
    if (!target) {
      return;
    }
    this.spinner.show();
    this.api.unlinkEquipo({id: target.idPos}).subscribe((res: any) => {
      console.log(res);
      this.unlinkTarget = null;
      this.unlinkError = null;
      this.loadScreens();
    }, (err) => {
      console.log(err);
      this.unlinkTarget = null;
      this.spinner.hide();
      const info: any = this.auth.checkError(err);
      this.unlinkError = (info && info.message) ? info.message : 'No se pudo desvincular';
    });
  }

}





// WEBPACK FOOTER //
// ./src/app/admin/home/home.component.ts